module.exports = __webpack_public_path__ + "static/media/vimeo.a99d1e7c.png";